import { DefaultTriggerList } from "../stepPages/step5/triggers/trigger";
import TriggerToStash from "../stepPages/step5/triggers/TriggerToStash";
import Indicator from "./Indicator";
import IndicatorDataSource from "./IndicatorDataSource";
import MediatorCalculated from "../stepPages/step3/MediatorCalculated";
import MediatorCollector from "../stepPages/step2/MediatorCollector";
import MediatorTrigger from "../stepPages/step5/MediatorTrigger";
import {SimpleNumberFormat} from "../../../../global"

var Mediator = {
  instance: function () {
    if (!Mediator.instance) {
      Mediator.instance = this;
    }
    return Mediator.instance;
  },

  editing: false,
  mainScreen: null,
  finisher: null,
  findIndicator: null,
  indicator: new Indicator(),
  triggers: new TriggerToStash(),
  steps: new Map(),
  data: {},

  async notify(sender, event) {

    switch (event) {
      case "init":
        this.mainScreen = sender
        if (localStorage.indicator) {
          this.indicator = new Indicator(JSON.parse(localStorage.indicator))
          this.triggers.setTriggerMap(this.indicator.triggers)
          sender.creatingIndicator = this.indicator.getIndicatorName();

          if (this.editing) {
            sender.actionType = this.editing ? "edit" : "new";
            sender.indicatorSelected = this.editing;
            sender.indicatorName = this.indicator.getIndicatorName()
          }
        }
        break

      case "init-step":
        initStep(sender)
        break

      case "init-finisher": {
        this.finisher = sender
        break;
      }

      case "initFindIndicator": {
        this.findIndicator = sender
        break;
      }

      case "findIndicator":{
        this.findIndicator.init(this.mainScreen.indicators)
        break;
      }

      case "save-stash": {
        await this.mainScreen.saveStash()
        this.notify(null, "clear-all")
        selectStep({ srcElement: { id: "step-1" } })
        if (this.mainScreen) {
          this.mainScreen.actionType = "new"
          this.mainScreen.indicatorSelected = null
        }
        break;
      }

      case "select-step":
        selectStep(sender)
        break

      case "select-step-by-form":
        selectStepByForm(sender)
        break;

      case "update-indicator":
        if(!this.mainScreen.canNext()){
          this.steps.get('step-1').canNext = false
          return
        }

        this.steps.get('step-1').canNext = true
        this.indicator = new Indicator({ ...this.indicator, ...sender })
        console.log("Indicator", this.indicator)
        this.indicator.triggers = this.triggers.getTriggerMap()
        if (this.mainScreen) {
          this.mainScreen.creatingIndicator = this.indicator.getIndicatorName();
        }
        localStorage.indicator = JSON.stringify(this.indicator)
        break;

      case "update-step-2":
        this.indicator.indRealList = sender.tagsCreated.map(i => new IndicatorDataSource(i))
        this.indicator.valueOnline = MediatorCollector.valueOnline
        this.indicator.valueDay = MediatorCollector.valueDay
        this.indicator.valueWeek = MediatorCollector.valueWeek
        this.indicator.valueMonth = MediatorCollector.valueMonth
        this.indicator.valueHarvest = MediatorCollector.valueHarvest
        localStorage.indicator = JSON.stringify(this.indicator)
        break;

      case "update-step-3":
        this.indicator.indPrevList = sender.tagsCreated.map(i => new IndicatorDataSource(i))

        this.indicator.targetOnline = MediatorCalculated.targetOnline
        this.indicator.targetDay = MediatorCalculated.targetDay
        this.indicator.targetWeek = MediatorCalculated.targetWeek
        this.indicator.targetMonth = MediatorCalculated.targetMonth
        this.indicator.targetHarvest = MediatorCalculated.targetHarvest

        localStorage.indicator = JSON.stringify(this.indicator)
        break;

      case "update-step-5":
        this.indicator.operatingRange = sender.operatingRange
        this.indicator.criticalRange = sender.criticalRange
        this.indicator.reliabilityThreshold = sender.reliabilityThreshold
        this.indicator.reliabilityCritical = sender.reliabilityCritical
        this.triggers.setTriggerConfigList(
          sender.processSelected, sender.productSelected, sender.equipmentSelected,
          DefaultTriggerList(this.data.indicatorTriggers))

        this.indicator.triggers = this.triggers.getTriggerMap();
        localStorage.indicator = JSON.stringify(this.indicator)
        break;

      case "set-indicator":
        this.notify(null, "clear-all")
        this.mainScreen.indicatorName = sender.text
        this.mainScreen.indicatorSelected = sender.value
        setIndicator(sender.value)
        break;

      case "clear-all":
        this.indicator = new Indicator();
        this.triggers = new TriggerToStash();
        delete localStorage.indicator;
        this.mainScreen.showdiscardStash = false;
        if (MediatorTrigger.triggersConfigVue)
          MediatorTrigger.triggersConfigVue.lockAll = true;

        this.steps.get("step-1").clearForm();
        break;

      case "add-position": {
        this.indicator.positions.push(sender)
        localStorage.indicator = JSON.stringify(this.indicator)
        break;
      }

      case "update-note": {
        this.indicator.note = { ...this.indicator.note, ...sender }
        localStorage.indicator = JSON.stringify(this.indicator)
        break;
      }

      case "remove-position": {
        let index = this.indicator.positions.indexOf(sender)
        let split = sender.split("|")

        if (split.length > 5 && index == -1) {
          split.pop()
          sender = split.join("|")
          index = this.indicator.positions.indexOf(sender)
        }

        // Remove a posição caso encontre
        if (index != -1)
          this.indicator.positions.splice(index, 1)

        // Verifica dentro das telas se também esta lá dentro.
        for (const screen of this.indicator.createScreen) {
          let childrenFound = screen.children.find(s => s.data.keyNodeSelected == sender)
          if (childrenFound) {
            screen.children = new Array()
            break;
          }

          for (const child of screen.children) {
            childrenFound = child.children.find(c => c.data.keyNodeSelected == sender)

            if (childrenFound) {
              child.children = new Array()
              break;
            }
          }
        }

        localStorage.indicator = JSON.stringify(this.indicator)
        break;
      }

      case "add-screen": {
        let index = 0
        let idParent = sender.id
        let idChildren = sender.children[0] ? sender.children[0].id : null

        // Busca por parente existente para adiciona-lo
        let parentFound = null;
        for (const parent of this.indicator.createScreen) {
          if (parent.id == sender.parent.id) {
            parentFound = sender.parent
            break;
          }
          index++
        }

        // Se encontrado remove o antigo e adiciona o novo atualizado.
        if (parentFound) {
          let idParent = parentFound.id
          let idChildren = parentFound.children[0].id
          parentFound = JSON.parse(JSON.stringify(parentFound))
          delete parentFound.parent
          delete parentFound.tree

          parentFound.id = idParent
          parentFound.children[0].id = idChildren
          this.indicator.createScreen.splice(index, 1, parentFound)
          localStorage.indicator = JSON.stringify(this.indicator)
          break;
        }

        let senderParsed = JSON.parse(JSON.stringify(sender))
        senderParsed.id = idParent;

        if (idChildren)
          senderParsed.children[0].id = idChildren

        delete senderParsed.parent
        delete senderParsed.tree
        senderParsed.children.forEach(c => {
          delete c.parent
          delete c.tree
          c.children = new Array();
        })

        this.indicator.createScreen.push(senderParsed)
        localStorage.indicator = JSON.stringify(this.indicator)
        break;
      }

      case "remove-screen": {
        let index = 0;
        let removedInside = false;
        let screenFound = false;
        if (!this.indicator.createScreen || this.indicator.createScreen.length == 0)
          return

        for (const screen of this.indicator.createScreen) {
          if (screen.data.text == sender.data.text) {
            screenFound = true;
            break
          }

          let childrenFound = screen.children.find(c => c.data.text == sender.data.text)
          if (childrenFound) {
            removedInside = true;
            break;
          }

          index++
        }

        if (screenFound)
          this.indicator.createScreen.splice(index, 1)

        if (removedInside)
          this.indicator.createScreen[index].children = new Array();


        localStorage.indicator = JSON.stringify(this.indicator)
        break;
      }

      case "clean-positions": {
        this.indicator.createScreen = new Array();
        this.indicator.positions = new Array();
        localStorage.indicator = JSON.stringify(this.indicator)
        break;
      }

      case "update-indicatorRule": {
        this.indicator.setPoint = sender.setPoint
        this.indicator.indicatorRule = sender.indicatorRule
        this.indicator.criticalRange = sender.critic
        localStorage.indicator = JSON.stringify(this.indicator)
        break;
      }

      case "update-ranges": {
        this.indicator.operatingRange = sender.operatingRange
        this.indicator.criticalRange = sender.criticalRange
        this.indicator.reliabilityThreshold = sender.reliabilityThreshold
        this.indicator.reliabilityCritical = sender.reliabilityCritical

        let signal = this.indicator.indicatorRule.split(' ')[0]
        this.indicator.indicatorRule = `${signal} ${this.indicator.operatingRange} ${this.indicator.criticalRange}`

        localStorage.indicator = JSON.stringify(this.indicator)
        break;
      }

      case "save-trigger": {
        saveTriggers()
        break;
      }

      case "remove-trigger-config": {
        this.triggers.remove(sender)
        saveTriggers()
        break;
      }

      case "stash-aplied": {
        this.finisher.success = true
        this.notify(null, "clear-all")
        setTimeout(() => {
          this.mainScreen.blockAll = false
          this.mainScreen.indicatorSelected = null
        }, 3500);
        break;
      }

      case "stash-error": {
        this.finisher.error = true
        setTimeout(() => {
          this.mainScreen.blockAll = false
          this.steps.get("step-6").updating = false
        }, 3500);
        break;
      }

      case "updating-indicator": {
        this.mainScreen.blockAll = true
        break;
      }

      case "kill": {
        MediatorCalculated.instance = null;
        MediatorCollector.instance = null;
        MediatorTrigger.instance = null;
        this.instance = null;
        delete localStorage.indicator;
        break;
      }
    }
  },

  checkAdvancedCalcs(indicator, prefix) {
    let advancedCalcs = ["SUM(", "SUM (", "CSUM(", "CSUM (", "CCOUNT(", "CCOUNT (", "AVG(", "AVG (", "WAVG(", "WAVG (", "CAVG(", "CAVG (", "SUB(", "SUB (", "CSUB(", "CSUB (", "MUL(", "MUL (", "CMUL(", "CMUL (", "DIV(", "DIV (", "CDIV(", "CDIV (", "TRULE(", "TRULE (", "MAX(", "MAX (", "MIN(", "MIN (", "SQRT(", "SQRT (", "IF(", "IF ("];

    let { valueDay, valueHarvest, valueMonth, valueOnline, valueWeek, targetDay, targetHarvest, targetMonth, targetOnline, targetWeek } = indicator;

    let prefixTarget = false;
    let prefixValue = false;

    for (let calcs of advancedCalcs) {
      if (valueDay.toUpperCase().includes(calcs) ||
        valueHarvest.toUpperCase().includes(calcs) ||
        valueMonth.toUpperCase().includes(calcs) ||
        valueOnline.toUpperCase().includes(calcs) ||
        valueWeek.toUpperCase().includes(calcs)
      ) {
        prefixValue = true;
      }

      if (targetDay.toUpperCase().includes(calcs) ||
        targetHarvest.toUpperCase().includes(calcs) ||
        targetMonth.toUpperCase().includes(calcs) ||
        targetOnline.toUpperCase().includes(calcs) ||
        targetWeek.toUpperCase().includes(calcs)
      ) {
        prefixTarget = true;
      }
    }

    return prefix == "target" ? prefixTarget : prefixValue;
  }
}

function saveTriggers() {
  Mediator.indicator.triggers = Mediator.triggers.getTriggerMap();
  localStorage.indicator = JSON.stringify(Mediator.indicator)
}

function selectStep(sender) {
  document.getElementById(Mediator.mainScreen.showFormSelected).classList.remove("active");
  document.getElementById(sender.srcElement.id).classList.add("active")
  Mediator.mainScreen.showFormSelected = sender.srcElement.id
}

function selectStepByForm(sender) {
  document.getElementById(Mediator.mainScreen.showFormSelected).classList.remove("active");
  document.getElementById(sender.nextStep).classList.add("active");
  Mediator.mainScreen.showFormSelected = sender.nextStep
}

function initStep(sender) {
  Mediator.steps.set(sender.step, sender)

  if (sender.step == "step-1") {
    if (!Mediator.indicator)
      Mediator.indicator = new Indicator();

    let ind = Mediator.indicator.getIndcatorStep1()
    sender.updateInd(ind)
  }

  if (sender.step == "step-2" || sender.step == "step-3") {
    sender.loadTagsCreated(Mediator.indicator)
  }

  if (sender.step == "step-5") {
    sender.processList = [...sender.processList, ...Mediator.data.productionProcess.map(p => ({ value: p.id, text: p.description }))]
    sender.productList = [...sender.productList, ...Mediator.data.productionProducts.map(p => ({ value: p.id, text: p.description }))]
    sender.equipmentList = [...sender.equipmentList, ...Mediator.data.productionEquipments.map(p => ({ value: p.id, text: p.description }))]
  }
}

function setIndicator(sender) {
  setTimeout(async () => {
    let stashFound = Mediator.data.indicatorsStashed.find(i => `${i.id}-${i.productionUnitId}-${i.system}` == sender)
    Mediator.editing = sender;
    let indicator = null;

    if(stashFound) Mediator.mainScreen.showdiscardStash = true;

    if (!stashFound && sender) {
      Mediator.mainScreen.loadingContent = true;
      stashFound = await Mediator.mainScreen.buildStash(sender);
    }

    if (!stashFound) return;

    indicator = new Indicator(stashFound)

    if(indicator.indRealList.length > 0){
      indicator.indRealList.forEach(realList => {
        if(realList.variables.length > 0 && realList.variables[0].tag && realList.variables[0].tag != undefined && realList.variables[0].tag != null){
          realList.variables[0].tag = realList.variables[0].tag.replace(/\\\\/g, "\\")
        }
      })
    }

    if(indicator.setPoint == "" && indicator.targetOnline != ""){
      let formatedIndicatorPrev = indicator.targetOnline.replaceAll("Map-","")
      let mathRegex = /[+*\/-]/g;
      let match = formatedIndicatorPrev.match(mathRegex);
      
      if(match != null && match.length > 0){
        let expressionArr = formatedIndicatorPrev.split(" ");
        if(!expressionArr.includes("")){
          Mediator.mainScreen.showPrevError = false;

          let expressionWithNumber = expressionArr.map(item => {
            if(item.trim() == "" || ["+","-","*","/","(",")"].includes(item.trim()))
            {
              return item.trim()
            }else if(Mediator.data.xmlMapping[item.trim()]){
              return Mediator.data.xmlMapping[item.trim()]
            }else if(item.trim().toLowerCase().includes("const")){
              console.log(item.trim().split(":")[1])
              return item.trim().split(":")[1]
            }
          }).join(" ")
          let expressionSolved = eval(expressionWithNumber)
          indicator.setPoint = SimpleNumberFormat(expressionSolved)
        }else{
          Mediator.mainScreen.showPrevError = true;
        }
      }else if(Mediator.data.xmlMapping[formatedIndicatorPrev]){
        Mediator.mainScreen.showPrevError = false;
        indicator.setPoint = SimpleNumberFormat(Mediator.data.xmlMapping[formatedIndicatorPrev])
      } else if(indicator.targetOnline.toLowerCase().includes("const")){
        Mediator.mainScreen.showPrevError = false;
        let constVal = indicator.targetOnline.split(":")[1]

        if(constVal) indicator.setPoint = SimpleNumberFormat(constVal)
      }      
    }

    Mediator.indicator = indicator;

    Mediator.triggers = stashFound.triggers ? new TriggerToStash(JSON.parse(stashFound.triggers)) : new TriggerToStash({})
    
    
    localStorage.indicator = JSON.stringify(indicator)
    
    document.querySelector("#step-1").click()
    setTimeout(() => {
      Mediator.steps.get("step-1").updateInd(indicator.getIndcatorStep1())
      Mediator.steps.get("step-1").isNew = false;

    }, 50);
    Mediator.mainScreen.loadingContent = false;
  }, 200);
}

export default Mediator